import React, { Component } from "react";
import { Link } from "react-router-dom";
import {
  Icon,
  Row,
  Col,
  Input,
  Avatar,
  Button,
  Form,
  message,
  Typography,
} from "antd";
import axios from "axios";
import WebFont from "webfontloader";
import OtpInput from "react-otp-input";
import "./sign-in.scss";
import Logo from "./Logo.svg";
import SuccessLogo from "./SuccessLogo.svg";
import backGround from "./forgotPasswordLogo.png";
import isDev from "../../server";
import { fetchAdminUserTypeApi } from "utils/apiService";
import { useState } from "react";
const { Text } = Typography;
const serverUrl = isDev();

const ForgotPassword = () => {
  const [OTP, setOTP] = useState(777777);
  const LandingPage = (props) => {
    return (
      <>
        <div
          style={{
            textAlign: "center",
            //   display: "flex",
            //   justifyContent: "center",
            //   flexDirection: "column",
          }}
        >
          <div>
            <img
              src={Logo}
              style={{
                width: "87.14px",
                height: "31.33px",
                marginTop: "32px",
                //   margin: "32px",
                marginBottom: "20px",
              }}
            ></img>
          </div>
          <div>
            {/* <Logo /> */}
            <Text
              style={{
                //   position: "absolute",
                //   top: "calc(50% - 31.33px/2 - 0.33px)",
                fontFamily: "Gotham",
                fontStyle: "normal",
                fontWeight: "1000",
                fontSize: "24px",
                lineHeight: "40px",
                color: "#181818",
                //   marginTop: "1px",
              }}
            >
              Password Assistance
            </Text>
          </div>
          <div
            style={{
              color: "#98a6ad",
              textAlign: "center",
              // marginTop: "8px",
            }}
          >
            Enter the email address associated with Banat Al Nujoom
          </div>
        </div>
        <Row
          type="flex"
          align="middle"
          justify="center"
          className="signin-form-container"
        >
          <Col span={24}>
            <Row>
              <div>
                <Text
                  style={{
                    fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#181818",
                    marginTop: "32px",
                  }}
                >
                  Email
                </Text>
              </div>

              <Input
                placeholder="Enter your email"
                style={{ border: "2px", marginTop: "4px" }}
              />
            </Row>

            <Row
              style={{
                marginTop: "18px",
                marginBottom: "32px",
              }}
            >
              <Text
                style={{
                  color: "#98a6ad",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  fontSize: "14px",
                  lineHeight: "24px",

                  alignItems: "center",

                  color: "#747474",
                  marginTop: "18px",
                }}
              >
                If you are facing any issue .You may contact{" "}
                <a
                  style={{
                    color: "#fec708",
                    fontWeight: "700",
                  }}
                >
                  Customer Service
                </a>{" "}
                for help restoring access to your account
              </Text>
            </Row>
            <Row>
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => {
                  setcurrentPage(VerifactionPage);
                }}
                style={{
                  width: "100%",
                  height: "40px",
                  background: "#fec708",
                }}
              >
                Next
              </Button>
            </Row>
          </Col>
        </Row>
      </>
    );
  };
  const UpdatePasswordPage = () => {
    return (
      <>
        <div
          style={{
            textAlign: "center",
            //   display: "flex",
            //   justifyContent: "center",
            //   flexDirection: "column",
          }}
        >
          <div>
            <img
              src={Logo}
              style={{
                width: "87.14px",
                height: "31.33px",
                marginTop: "32px",
                //   margin: "32px",
                marginBottom: "20px",
              }}
            ></img>
          </div>
          <div>
            {/* <Logo /> */}
            <Text
              style={{
                //   position: "absolute",
                //   top: "calc(50% - 31.33px/2 - 0.33px)",
                fontFamily: "Gotham",
                fontStyle: "normal",
                fontWeight: "1000",
                fontSize: "24px",
                lineHeight: "40px",
                color: "#181818",
                //   marginTop: "1px",
              }}
            >
              Create a New Password
            </Text>
          </div>
          <div
            style={{
              color: "#98a6ad",
              textAlign: "center",
              // marginTop: "8px",
            }}
          >
            We wil ask for the password whenever you sign in
          </div>
        </div>
        <Row
          type="flex"
          align="middle"
          justify="center"
          className="signin-form-container"
        >
          <Col span={24}>
            <Row>
              <div>
                <Text
                  style={{
                    fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#181818",
                    marginTop: "32px",
                  }}
                >
                  New Password
                </Text>
              </div>

              <Input
                placeholder="Enter New Password"
                style={{ border: "2px", marginTop: "4px" }}
              />
            </Row>
            <Row style={{ marginTop: "32px" }}>
              <div>
                <Text
                  style={{
                    fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#181818",
                    marginTop: "32px",
                  }}
                >
                  Confirm New Password
                </Text>
              </div>

              <Input
                placeholder="Confirm New Password"
                style={{ border: "2px", marginTop: "4px" }}
              />
            </Row>

            <Row
              style={{
                marginTop: "32px",
                marginBottom: "32px",
              }}
            >
              <Button
                type="primary"
                htmlType="submit"
                //   onClick={() => {
                //     message.error(
                //       "Something went wrong! Please try again latter"
                //     );
                //   }}
                style={{
                  width: "100%",
                  height: "40px",
                  background: "#fec708",
                }}
              >
                Update Password
              </Button>
            </Row>
            <Row>
              <Text
                style={{
                  color: "#98a6ad",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  fontSize: "14px",
                  lineHeight: "24px",

                  alignItems: "center",

                  color: "#747474",
                  marginTop: "18px",
                }}
              >
                <span
                  style={{
                    color: "#181818",
                    fontWeight: "700",
                  }}
                >
                  Secured Password Tips:
                </span>
                <ul
                  style={{
                    listStyle: "none",
                  }}
                >
                  <li>Use atleast 8 charaters</li>

                  <li>Use a combination of numbers and letters </li>

                  <li>Use atleast one special charater in your password</li>
                </ul>
              </Text>
            </Row>
          </Col>
        </Row>
      </>
    );
  };
  const VerifactionPage = () => {
    return (
      <>
        <div
          style={{
            textAlign: "center",
          }}
        >
          <div>
            <img
              src={Logo}
              style={{
                width: "87.14px",
                height: "31.33px",
                marginTop: "32px",
                marginBottom: "20px",
              }}
            ></img>
          </div>
          <div>
            {/* <Logo /> */}
            <Text
              style={{
                fontFamily: "Gotham",
                fontStyle: "normal",
                fontWeight: "1000",
                fontSize: "24px",
                lineHeight: "40px",
                color: "#181818",
              }}
            >
              Verification Required
            </Text>
          </div>
          <div
            style={{
              color: "#98a6ad",
              textAlign: "center",
            }}
          >
            An OTP has been sent to
          </div>
          <div
            style={{
              color: "#98a6ad",
              textAlign: "center",
              // marginTop: "8px",
            }}
          >
            {" "}
            username@banalnujoom.com
          </div>
        </div>
        <Row
          type="flex"
          align="middle"
          justify="center"
          className="signin-form-container"
        >
          <Col span={24}>
            <Row>
              <div>
                <Text
                  style={{
                    fontStyle: "normal",
                    fontWeight: "bold",
                    fontSize: "14px",
                    lineHeight: "24px",
                    color: "#181818",
                    marginTop: "32px",
                  }}
                >
                  Enter OTP
                </Text>
              </div>
              <div style={{ width: "100%", marginTop: "8px" }}>
                <OtpInput
                  inputStyle={{
                    width: "100%",
                    height: "50px",
                    border: "1px solid #A3A3A3",
                    borderRadius: "4px",
                  }}
                  size={100}
                  value={OTP}
                  masked={false}
                  numeric={true}
                  onChange={(e) => {
                    setOTP(e);
                  }}
                  numInputs={6}
                  separator={<span style={{ width: "20px" }}> </span>}
                  width={1000}
                />
              </div>
            </Row>

            <Row
              style={{
                marginTop: "32px",
              }}
            >
              <Button
                type="primary"
                style={{
                  width: "100%",
                  height: "40px",
                  background: "#fec708",
                }}
              >
                Continue
              </Button>
            </Row>
            <Row
              style={{
                marginTop: "32px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Link
                style={{
                  color: "#fec708",
                }}
                onClick={() => {
                }}
              >
                {" "}
                Resend OTP
              </Link>
            </Row>
          </Col>
        </Row>
      </>
    );
  };
  const SuccessPage = () => {
    return (
      <>
        <div
          style={{
            textAlign: "center",
            //   display: "flex",
            //   justifyContent: "center",
            //   flexDirection: "column",
          }}
        >
          <div>
            <img
              src={SuccessLogo}
              style={{
                width: "100px",
                height: "100px",
                marginTop: "32px",
                //   margin: "32px",
                marginBottom: "20px",
              }}
            ></img>
          </div>
          <div>
            {/* <Logo /> */}
            <Text
              style={{
                //   position: "absolute",
                //   top: "calc(50% - 31.33px/2 - 0.33px)",
                fontFamily: "Gotham",
                fontStyle: "normal",
                fontWeight: "1000",
                fontSize: "24px",
                lineHeight: "40px",
                color: "#181818",
                //   marginTop: "1px",
              }}
            >
              Password Changed
            </Text>
          </div>
          <div
            style={{
              color: "#98a6ad",
              textAlign: "center",
              // marginTop: "8px",
            }}
          >
            The old password was successfully updated!
          </div>
        </div>
        <Row
          type="flex"
          align="middle"
          justify="center"
          className="signin-form-container"
        >
          <Col span={24}>
            <Row
              style={{
                display: "flex",
                justifyContent: "center",
                //   marginTop: "18px",
                marginBottom: "32px",
              }}
            >
              <Text
                style={{
                  color: "#98a6ad",
                  fontStyle: "normal",
                  fontWeight: "normal",
                  fontSize: "14px",
                  lineHeight: "24px",

                  alignItems: "center",

                  color: "#464646",
                  // marginTop: "18px",
                }}
              >
                Return to the login and enter new password
              </Text>
            </Row>
            <Row
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Button
                type="primary"
                style={{
                  width: "40%",
                  height: "40px",
                  background: "#fec708",
                }}
              >
                <Link to="/">Go to Login</Link>
              </Button>
            </Row>
          </Col>
        </Row>
      </>
    );
  };

  const [currentPage, setcurrentPage] = useState(LandingPage);
  return (
    <div
      style={{
        minHeight: "100vh",

        backgroundImage: `url(${backGround})`,
      }}
    >
      <div
        style={{
          // opacity: "0.5",
          background: "rgb(80, 80, 80, 0.5)",
        }}
      >
        <Row
          type="flex"
          align="middle"
          justify="center"
          style={{
            minHeight: "100vh",
          }}
        >
          <Col
            lg={8}
            style={{
              background: "white",
              width: "504px",
              opacity: "1 !important",
              // height: "480px",
              // marginTop: "210px",
            }}
          >
            {/* <LandingPage />
             */}
            {/* <VerifactionPage />
              <UpdatePasswordPage />
              <SuccessPage /> */}
            {currentPage}
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ForgotPassword;
